// Module
var code = "<p class=\"orange-marker\">For example, Sara Student has a $10,000 current principal balance and 6% interest rate this year.</p> <p>Using the formula for a non-leap year:</p> <p><strong>0.06 x $10,000 ÷ 365 = 1.6438356… (Round to $1.64)</strong></p> ";
// Exports
export default code;